/*jslint browser: true */
/*global window */


(function($){

// ---------------------------------------------- // 
// Scroll trigger functionality
// ---------------------------------------------- // 
// Use this function for any custom lazyloaded/interactions on scroll

   function scrollTrigger(selector, options = {}) {
      let els = document.querySelectorAll(selector)
      els = Array.from(els)
      els.forEach(el => {
        addObserver(el, options)
      })
    }
    function addObserver(el, options) {
      if(!('IntersectionObserver' in window)) {
        if(options.cb){
          options.cb(el)
        } else{
          entry.target.classList.add('active')
        }
        return
      }
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            if(options.cb) {
              options.cb(el)
            } else{
              entry.target.classList.add('active')
               // Iframe lazyloading
              if (entry.target.classList.contains('iframe-lazyload')) {
                  // Removes commented content within a container
                  let iframeContainer = entry.target;
                  let htmlContent = iframeContainer.innerHTML;
                  htmlContent = htmlContent.replace(/<!--/g, '').replace(/-->/g, '');
                  iframeContainer.innerHTML = htmlContent;
               }   
               // Video lazyloading
               if (entry.target.classList.contains('video-lazyload')) {
                  let vidContainer = entry.target;
                  let videoEl = vidContainer.querySelector('video');
                  let src = videoEl.getAttribute('data-src');
                  videoEl.setAttribute('src', src);
               } 
               // Image lazyloading
               if (entry.target.classList.contains('lozad')) {
                  let imgEl = entry.target;
                  let src = imgEl.getAttribute('data-src');
                  imgEl.setAttribute('src', src);
               } 
               // Statistics Counter
               if (entry.target.classList.contains('counter-wrap')) {
                  counter();
               } 
              // Statistics Boxes
              if (entry.target.classList.contains('stats-wrap')) {
                stat_counter();
              } 
            }
            observer.unobserve(entry.target)
          }
        })
      }, options)
      observer.observe(el)
    }

scrollTrigger('.iframe-lazyload', {
   rootMargin: '500px',
});
scrollTrigger('.lozad', {
   rootMargin: '200px',
});
scrollTrigger('.video-lazyload', {
   rootMargin: '500px',
});
scrollTrigger('.counter-wrap');
scrollTrigger('.stats-wrap');


//! *********************************
// Banner
//! ********************************

if ($('.banner-slider').length) {
   $('.banner-slider').slick({
      arrows: true,
      dots: false,
      autoplay: false,
      infinte: true,
      prevArrow: $('.banner-block .slide-arrow.prev'),
      nextArrow: $('.banner-block .slide-arrow.next'),
   });
}
if ($('.testimonial-slider').length) {
   $('.testimonial-slider').slick({
      arrows: true,
      dots: false,
      autoplay: false,
      infinte: true,
      prevArrow: $('.testimonials .slide-arrow.prev'),
      nextArrow: $('.testimonials .slide-arrow.next'),
   });
}

//! *********************************
//! To be separated into files
//! ********************************

//! *********************************
// Statistics Counter
//! ********************************

function counter(){
   $('.counter-item').each(function () {
     let num = $(this).find('.number').text();
     let decNum = (num.toString().split('.')[1] || '').length;
      $(this).find('.number').prop('Counter',0).animate({
          Counter: $(this).find('.number').text()
      }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
             $(this).text(parseFloat(now).toFixed(decNum));
          }
      });
      if ($(this).hasClass('ten')) {
        $(this).find('.progress').addClass('loadten');
      }
      if ($(this).hasClass('twenty')) {
        $(this).find('.progress').addClass('loadtwenty');
      }
      if ($(this).hasClass('twenty-five')) {
        $(this).find('.progress').addClass('loadtwentyfive');
      }
      if ($(this).hasClass('thirty')) {
        $(this).find('.progress').addClass('loadthirty');
      }
      if ($(this).hasClass('forty')) {
        $(this).find('.progress').addClass('loadforty');
      }
      if ($(this).hasClass('fifty')) {
        $(this).find('.progress').addClass('loadfifty');
      }
      if ($(this).hasClass('sixty')) {
        $(this).find('.progress').addClass('loadsixty');
      }
      if ($(this).hasClass('seventy')) {
        $(this).find('.progress').addClass('loadseventy');
      }
      if ($(this).hasClass('seventy-five')) {
        $(this).find('.progress').addClass('loadseventyfive');
      }
      if ($(this).hasClass('eighty')) {
        $(this).find('.progress').addClass('loadeighty');
      }
      if ($(this).hasClass('ninety')) {
        $(this).find('.progress').addClass('loadninety');
      }
      if ($(this).hasClass('one-hundred')) {
        $(this).find('.progress').addClass('loadonehundred');
      }
  });
}

// ---------------------------------------------- //
// Stats Counter
// ---------------------------------------------- //
function stat_counter(){
  $('.stats-item').each(function () {
    let num = $(this).find('.number').text();
    let decNum = (num.toString().split('.')[1] || '').length;
     $(this).find('.number').prop('Counter',0).animate({
         Counter: $(this).find('.number').text()
     }, {
         duration: 2000,
         easing: 'swing',
         step: function (now) {
            $(this).text(parseFloat(now).toFixed(decNum));
         }
     });
 });
}

// ---------------------------------------------- // 
// Responsive slick function
// ---------------------------------------------- // 


    // let winWidth = $(window).width();
   
    function detectSlick(el, options, breakpoint){
      const winWidth = $(window).width();
      if(el.length){
         if (!$(''+ el +'').hasClass('slick-initialized') && winWidth < breakpoint) {
             $(''+ el +'').slick(options);
         }
         if ($(''+ el +'').hasClass('slick-initialized') && winWidth > breakpoint) {
             $(''+ el +'').slick('unslick');
         }
      }
   }
  
   $(window).on('resize', function(){
     const winWidth = $(window).width();
     detectSlick('.feature-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 768);
     detectSlick('.cta-columns-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 525);
   });
  
   detectSlick('.feature-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 768);
   detectSlick('.cta-columns-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 525);



})(jQuery);